module.exports = __webpack_public_path__ + "assets/img/2.9dc506cd.png";